var e = {
	nav: { experiences: "Experiences" },
	list: {
		title: "Experiences",
		subtitle: "Guided sessions you run on a schedule.",
		create: "Create experience",
		searchPlaceholder: "Search experiences",
		listingCount_one: "{{count}} option",
		listingCount_other: "{{count}} options",
		empty: {
			title: "No experiences yet",
			message: "An experience is something you run on a schedule — a cooking class, a diving trip, a walking tour. Add one and we'll open its calendar.",
			action: "Create your first experience"
		},
		emptyFiltered: {
			title: "Nothing matches those filters",
			message: "No experience matches what you searched for.",
			action: "Clear filters"
		},
		allStatuses: "All statuses",
		allCategories: "All categories"
	},
	card: {
		startsFrom: "From",
		perPerson: "per person",
		noPrice: "No options priced yet",
		nextSession: "Next session {{at}}",
		noSessions: "No sessions scheduled",
		imageAlt: "Cover photo of {{title}}",
		noPhoto: "No cover photo"
	},
	detail: {
		sessionLength: "{{minutes}} minutes per session",
		capacity_one: "{{count}} seat per session",
		capacity_other: "{{count}} seats per session",
		minAge: "Ages {{age}} and over",
		languages: "Run in {{languages}}",
		meetingPoint: "Meeting point",
		whatIsIncluded: "What's included",
		whatToBring: "What to bring",
		options: "Options",
		noOptions: "No options published yet — a guest cannot book until one exists.",
		nextSession: "Next session",
		nextSessionNone: "None scheduled",
		seatsSoldThisMonth: "Seats sold this month",
		viewSessions: "View sessions",
		managePhotos: "Manage photos",
		quickActions: "Quick actions",
		editDetails: "Edit experience",
		archive: "Archive experience",
		archiveConfirmTitle: "Archive this experience?",
		archiveConfirmBody: "Guests will no longer be able to find or book it. This can't be undone from here.",
		archived: "Experience archived.",
		archiveFailed: "Couldn't archive this experience.",
		about: "About this experience",
		headerSummary: "{{category}} · {{minutes}} minutes per session",
		headerSummaryNoCategory: "{{minutes}} minutes per session",
		place: "Meeting point",
		schedule: "Weekly schedule",
		scheduleWeekdays: "Runs on {{days}}",
		scheduleStartTimes: "Starting at {{times}}",
		scheduleHorizon: "Sessions are opened {{days}} days ahead.",
		scheduleNone: "No schedule yet — add one and we'll start opening sessions.",
		bookingCutoff: "Bookings close {{minutes}} minutes before a session starts.",
		bookingCutoffNone: "Guests can book right up to the start."
	},
	form: {
		titleInternal: "Internal name",
		titleInternalHint: "Only you see this. The name guests see belongs to each option.",
		category: "Category",
		durationMinutes: "How long is one session?",
		defaultCapacity: "Seats per session",
		minAge: "Minimum age",
		languages: "Languages",
		whatIsIncluded: "What's included",
		whatToBring: "What to bring",
		meetingPointAddress: "Meeting point",
		meetingPointDirections: "How to find it",
		timezone: "Time zone",
		timezoneHint: "Sessions are scheduled in this zone, not yours.",
		bookingCutoff: "Stop taking bookings",
		bookingCutoffHint: "How close to a session's start a guest can still book."
	},
	schedule: {
		title: "Weekly schedule",
		subtitle: "We open sessions ahead of time from this pattern. Add one-off sessions on the calendar.",
		weekdays: "Days",
		startTimes: "Start times",
		addStartTime: "Add a start time",
		horizonDays: "Open sessions this far ahead",
		duplicateStartTime: "Two sessions can't start at the same time on the same day."
	},
	errors: {
		featureUnavailable: "Experiences aren't available yet.",
		hasActiveListings_one: "{{count}} option is still bookable. Unpublish it before archiving this experience.",
		hasActiveListings_other: "{{count}} options are still bookable. Unpublish them before archiving this experience.",
		archived: "This experience is archived."
	},
	wizard: {
		start: "Get started",
		finish: "Create experience",
		back: "Back",
		next: "Next",
		story: {
			title: "Tell guests what this is",
			guestTitle: "Title",
			guestTitleHint: "What guests see when they browse experiences.",
			guestDescription: "Description"
		},
		format: {
			title: "How it runs",
			minGroupSize: "Minimum group size",
			minGroupSizeHint: "Below this, we still charge for the minimum (a guest sees the total up front).",
			maxGroupSize: "Maximum group size"
		},
		photos: {
			title: "Add photos",
			hint: "Your first photo is the cover. A few more are needed before you can publish.",
			minimum: "A cover photo and at least {{count}} photos before you can publish.",
			addPhotos: "Add photos",
			cover: "Cover",
			makeCover: "Make cover",
			minRemaining_one: "{{count}} more photo to go",
			minRemaining_other: "{{count}} more photos to go",
			empty: "No photos yet.",
			rejected: "Some files were skipped — only images up to {{maxMb}} MB are accepted."
		},
		price: {
			title: "Set your price",
			basePrice: "Price per person",
			currency: "Currency",
			privateGroupPrice: "Private group price",
			privateGroupPriceHint: "A flat price for the whole session, instead of per person. Leave empty to not offer it."
		},
		review: {
			title: "Review & publish",
			createFailed: "We couldn't create this experience. Try again.",
			listingFailedTitle: "The experience was created, but publishing failed",
			listingFailedBody: "Your experience is saved as a draft. Try publishing again below — nothing you entered was lost.",
			publishing: "Publishing…",
			photoCount_one: "{{count}} photo",
			photoCount_other: "{{count}} photos",
			editSection: "Edit",
			previewCaption: "What a guest sees",
			viewExperience: "View your experience",
			retry: "Try again",
			publishNote: {
				title: "When you publish",
				live: "Your experience goes live and guests can find it straight away.",
				sessions: "We open sessions from your weekly schedule and keep them topped up.",
				editable: "You can edit everything, add more options and add one-off sessions afterwards."
			},
			groupMin: "Minimum group of {{count}}",
			groupMax: "Maximum group of {{count}}",
			privateGroup: "{{price}} for a private group",
			horizonDays_one: "Sessions open {{count}} day ahead",
			horizonDays_other: "Sessions open {{count}} days ahead"
		},
		place: {
			title: "Where do guests meet you?",
			enterManually: "Enter it manually",
			searchCta: "Search for the address",
			useCurrentLocation: "Use my current location",
			pinTitle: "Drop the exact pin",
			pinSubtitle: "Drag the map so the pin sits where it really is."
		},
		exitTitle: "Leave without saving?",
		exitBody: "Nothing is saved until you publish, so this experience won't be here when you come back.",
		exitConfirm: "Discard",
		animations: {
			entryTitle: "Let's create your experience",
			entrySubtitle: "A few questions about what you run, where it happens and when. You can change any of it afterwards.",
			photosTitle: "Now the photos",
			photosSubtitle: "Guests decide from the pictures. Lead with the one that shows what the session actually feels like.",
			completionTitle: "Your experience is live",
			completionSubtitle: "Guests can find it and book a session. Sessions open from your weekly schedule from now on."
		},
		submitting: {
			settingUp: "Setting things up",
			creating: "Creating your experience…",
			uploading: "Uploading your photos…",
			publishing: "Publishing your first option…",
			oops: "That didn't go through"
		}
	},
	sessions: {
		pageTitle: "Sessions",
		pageSubtitle: "The sessions generated from your weekly schedule, plus any one-off you add.",
		addSession: "Add session",
		addSessionOnDay: "Add a session on {{date}}",
		bookedOfCapacity: "{{booked}}/{{capacity}} booked",
		aboutRemaining_one: "about {{count}} seat left",
		aboutRemaining_other: "about {{count}} seats left",
		full: "Full",
		editTitle: "Edit session",
		addTitle: "Add a session",
		alreadyCancelled: "This session is cancelled.",
		dateLabel: "Date",
		timeLabel: "Start time",
		capacityLabel: "Seats",
		timezoneNote: "Times are in {{zone}}.",
		cancelSession: "Cancel session",
		saved: "Session updated.",
		created: "Session added.",
		cancelled: "Session cancelled.",
		saveFailed: "Couldn't save this session.",
		cancelFailed: "Couldn't cancel this session.",
		slotHasSeats: "{{held}} held and {{booked}} booked — you can't cancel a session guests are on. Cancel their bookings first, so they're told and refunded.",
		dayHeading: "Sessions on {{date}}",
		dayEmpty: "No sessions on this day.",
		pickADay: "Pick a day to see its sessions.",
		timeRange: "{{start}} – {{end}}",
		cancelledLabel: "Cancelled",
		cancelConfirmTitle: "Cancel this session?",
		cancelConfirmBody: "Guests can no longer book it. A session that already has guests on it can't be cancelled here.",
		emptyMonthTitle: "No sessions this month",
		emptyMonthBody: "Sessions generated from your weekly schedule appear here. You can also add a one-off.",
		noScheduleTitle: "No schedule yet",
		noScheduleBody: "Sessions are generated from a weekly schedule. Until one is set, you can still add one-off sessions here."
	},
	photos: {
		empty: "No photos yet. Guests browse with their eyes — add a few before you publish.",
		rejected: "Those files couldn't be used — JPEG, PNG or WebP only, and under the size limit.",
		uploadFailed: "Couldn't add those photos. Try again.",
		deleteFailed: "Couldn't remove that photo. Try again."
	},
	guest: {
		hostedBy: "Experience hosted by {{host}}",
		durationLine: "{{duration}}",
		languagesLine: "Hosted in {{languages}}",
		whatYouWillDo: "What you'll do",
		whatToBring: "What to bring",
		thingsToKnow: "Things to know",
		guestRequirements: "Guest requirements",
		minAge: "Guests aged {{age}} and up can attend.",
		maxGroup: "Up to {{count}} guests in total.",
		cancellationPolicy: "Cancellation policy",
		meetingPoint: "Where you'll meet",
		chooseFromDates: "Choose from available dates",
		showMoreDates: "Show more dates",
		similar: "Similar experiences",
		suspended: "This experience isn't taking new bookings right now.",
		notFound: {
			title: "This experience isn't available",
			body: "It may have been removed, or it isn't published yet."
		}
	},
	edit: {
		detailsTitle: "Edit experience",
		detailsSubtitle: "Everything here replaces what guests and the schedule read today.",
		photosTitle: "Edit photos",
		photosSubtitle: "A cover photo and at least {{count}} photos before you can publish.",
		saved: "Changes saved.",
		saveFailed: "Couldn't save your changes. Nothing was lost — try again.",
		photosNotUploaded_one: "{{count}} photo couldn't be uploaded",
		photosNotUploaded_other: "{{count}} photos couldn't be uploaded"
	},
	options: {
		addOption: "Add option",
		created: "Option added.",
		createFailed: "Couldn't add this option."
	}
};
//#endregion
export { e as default };
